import { roundDecimal } from '@erp/shared';

/** Preserve all ledger decimals; Intl only receives an exact integer BigInt. */
export function formatLedgerMoney(value: string, currency: string, locale: string): string {
  const normalized = roundDecimal(value, 4);
  const negative = normalized.startsWith('-');
  const [integer = '0', fraction = '0000'] = (negative ? normalized.slice(1) : normalized).split(
    '.',
  );
  const whole = BigInt(integer);
  const negativeFraction = negative && whole === 0n;
  const formatted = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).formatToParts(negativeFraction ? -1n : negative ? -whole : whole);
  const exactFraction = fraction.replace(/0+$/u, '').padEnd(2, '0');
  return formatted
    .map((part) =>
      part.type === 'fraction'
        ? exactFraction
        : negativeFraction && part.type === 'integer'
          ? '0'
          : part.value,
    )
    .join('');
}
